/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $header                  : $('header'),
    $burgerNav               : $('.burgerNav'),
    $burgerMenu              : $('.burger-menu'),
    $searchForm              : $('#headerSearch'),
    $searchStore             : $('#searchStore'),
    $closeSearch             : $('#closeSearch'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('.featuredImage img'),
    $productImages           : $('.productImage'),
    $thumbImages             : $('.productThumbs').find('a'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};


timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.productImageSwitch();
  timber.loginForms();
  timber.navMenu();
};


timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function ($container, options) {

  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $addToCart = $container.find('.add-to-cart'),
      $productPrice = $container.find('.product-price'),
      $comparePrice = $container.find('.compare-price'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $container.find('.add-to-cart-text'),
      $paymentButton = $container.find(".shopify-payment-button");

  if ( !variant || !variant.available ) {
    $paymentButton.hide();
  } else {
    $paymentButton.show();
  }

  if (variant) {


    // Update variant image, if one is set
    if ( variant.featured_image ) {
      timber.cache.$productImages
        .hide()
        .filter("[data-image-id=" + variant.featured_image.id + "]")
          .show();

      timber.cache.$thumbImages
        .removeClass("active")
        .filter("[data-image-id=" + variant.featured_image.id + "]")
          .addClass("active");
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Sold Out");
    $quantityElements.hide();
  }
};

timber.productPageRegular = function ($container, options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $container.find('.featuredImage img'),
      $addToCart = $container.find('.add-to-cart'),
      $productPrice = $container.find('.product-price'),
      $comparePrice = $container.find('.compare-price'),
      $quantityElements = $container.find('.quantity-selector, label + .js-qty'),
      $addToCartText = $container.find('.add-to-cart-text'),
      $paymentButton = $container.find(".shopify-payment-button");

  if ( !variant || !variant.available ) {
    $paymentButton.hide();
  } else {
    $paymentButton.show();
  }

  if (variant) {

    // Update variant image, if one is set
    if ( variant.featured_image ) {
      timber.cache.$productImages
        .hide()
        .filter("[data-image-id=" + variant.featured_image.id + "]")
          .show();

      timber.cache.$thumbImages
        .removeClass("active")
        .filter("[data-image-id=" + variant.featured_image.id + "]")
          .addClass("active");
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Sold Out");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {

  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();

      var thumb = $(this)
      var index = timber.cache.$thumbImages.index(this);

      timber.cache.$thumbImages.removeClass('active');
      thumb.addClass('active');

      timber.cache.$productImages
        .hide()
        .eq(index)
          .show();
    });
  }
};


timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};



timber.navMenu = function () {

  timber.openMenu = function () {
    timber.cache.$burgerNav.addClass('active');
    timber.cache.$burgerMenu.addClass('active');
  }

  timber.closeMenu = function () {
    timber.cache.$burgerNav.removeClass('active');
    timber.cache.$burgerMenu.removeClass('active');
  }

  timber.cache.$burgerNav.on('click', function (evt) {
    evt.preventDefault();

    if ( !$(this).hasClass('active') ) {
      timber.openMenu();
    } else {
      timber.closeMenu();
    }
  });

  timber.cache.$burgerMenu.find('.burger-dropdown-link').each(function () {
    $(this).on("click", function (evt) {
      evt.preventDefault();
      $(this).toggleClass("active");
    });
  });

  timber.cache.$searchStore.on('click', function (evt) {
    evt.preventDefault();

    timber.cache.$searchForm.toggleClass("active");
    timber.cache.$header.toggleClass( "active" );

    setTimeout(function () {
      $('input[name="q"]').focus();
    }, 100);
  });

  timber.cache.$closeSearch.on('click', function (evt) {
    evt.preventDefault();
    timber.cache.$searchForm.toggleClass("active");
    timber.cache.$header.toggleClass("active");
  });
}

// Initialize Timber's JS on docready
$(timber.init);
